import FirebaseInstance from "./firebase.js";

const Firebase = (function () {
    const instance = {};

    return {
        getInstance(instanceType = "DEFAULT") {
            if (!instance[instanceType]) {
                instance[instanceType] = new FirebaseInstance(instanceType);
            }
            return instance[instanceType];
        }
    };
})();

export default Firebase;
